jQuery.event.special.touchstart = {
  setup: function (_, ns, handle) {
    if (ns.includes("noPreventDefault")) {
      this.addEventListener("touchstart", handle, { passive: false });
    } else {
      this.addEventListener("touchstart", handle, { passive: true });
    }
  },
};

jQuery.event.special.touchmove = {
  setup: function (_, ns, handle) {
    if (ns.includes("noPreventDefault")) {
      this.addEventListener("touchmove", handle, { passive: false });
    } else {
      this.addEventListener("touchmove", handle, { passive: true });
    }
  },
};

$(".side-menu").on("click", function () {
  $("#main-navi").toggleClass("navi-open");
});

$("#hamburger").on("click", function () {
  $("#main-navi").toggleClass("navi-open");
});

$(".close-navi").on("click", function () {
  $("#main-navi").removeClass("navi-open");
  $("body").removeClass("overflow");
});

$("li.level1").on("click", function () {
  $("li.level1").not(this).removeClass("open-navi");
  $(this).addClass("open-navi");
});

/**** USER LOGIN ****/

getUserStatus();

function getUserStatus() {
  $.get("/cart/status", function (response) {
    var data = JSON.parse(response);

    if (data.user != null) {
      $(".user-login").addClass("active");
      $(".user-login").attr("title", "Moj profil");
    } else {
      $(".user-login").removeClass("active");
      $(".user-login").attr("title", "Prijavi se");
    }
  });
}

/**** END USER LOGIN ****/

/**** SLIDERS ****/

$(function () {
  if ($(".exposed-products").length > 0) {
    new Splide(".exposed-products", {
      arrows: true,
      drag: true,
      autoplay: false,
      pagination: false,
      speed: 3000,
      rewind: true,
      fixedWidth: "240px",
      type: "slide",
      gap: 16,
      breakpoints: {
        769: {
          fixedWidth: "170px",
        },
      },
    }).mount();
  }
});

if ($(".exposed-action").length > 0) {
  document.addEventListener("DOMContentLoaded", function () {
    var splideOf = new Splide(".exposed-action", {
      pagination: true,
      arrows: true,
      drag: true,
      autoplay: false,
      speed: 3000,
      rewind: true,
      perPage: 4,
      type: "slide",
      padding: 20,
      breakpoints: {
        1400: {
          arrows: false,
        },
        1024: {
          perPage: 3,
        },
        720: {
          perPage: 2,
          padding: 10,
        },
        350: {
          perPage: 1,
        },
      },
    }).mount();
  });
}

/**** END SLIDERS ****/

/**** MENU ****/

$("#hamburger").on("click", function () {
  $("body").toggleClass("overflow");
  $(".bot-header").toggleClass("open");
});

$(".mobile-hamburger").on("click", function () {
  $("body").removeClass("overflow");
  $(".bot-header").removeClass("open");
});

$(".show-more").on("click", function () {
  $(this).parent("li.level1").children(".level-two").toggle();
});

$(window).on("scroll", function () {
  if ($(this).scrollTop() >= 40) {
    $(".header-container").addClass("scroll");
    $(".main-navi-wrapper").addClass("scroll");
    $(".side-menu-wrapper").addClass("scroll");
  } else {
    $(".header-container").removeClass("scroll");
    $(".main-navi-wrapper").removeClass("scroll");
    $(".side-menu-wrapper").removeClass("scroll");
  }
});

/**** END MENU ****/

/*** AUTOCOMPLETE ****/
var searchInput = $("#header-search-input");
var searchResults = $(".smart-search-results");
if (searchInput.length > 0) {
  var debounceTimer;
  var minCharacters = 3;
  var searchVersion = 0;

  searchInput.on("input", function () {
    clearTimeout(debounceTimer);
    var version = ++searchVersion;

    if ($(this).val().length >= minCharacters) {
      debounceTimer = setTimeout(function () {
        performSearch(searchInput.val(), version);
      }, 500);
    } else {
      searchResults.empty().hide();
    }
  });

  function performSearch(query, version) {
    $.ajax({
      url: "/search/autocomplete/",
      data: { term: query },
      success: function (data) {
        if (version !== searchVersion) {
          return;
        }
        searchResults.html(data).show();
        smartSearchPrices();
      },
      error: function (error) {
        if (version !== searchVersion) {
          return;
        }
        console.error("Error fetching search results:", error);
        searchResults.empty().hide();
      },
    });
  }

  function smartSearchPrices() {
    // Keep references to this response's rows; later searches replace these nodes.
    var rows = searchResults.find(".single-result[data-product-id]");
    var loaders = searchResults.find(".list-loader");
    var prices = searchResults.find(".price");
    var productIds = [];
    rows.each(function () {
      var id = $(this).attr("data-product-id");
      if (id && productIds.indexOf(id) === -1) {
        productIds.push(id);
      }
    });

    function finish() {
      loaders.hide();
      prices.show();
    }

    if (!productIds.length) {
      finish();
      return;
    }
    loaders.show();
    $.ajax({
      type: "GET",
      url: "/product/get-prices",
      data: { products: productIds.join(";") },
      dataType: "json",
      timeout: 15000,
      success: function (data) {
        if (!data || typeof data !== "object") {
          return;
        }
        rows.each(function () {
          var row = $(this);
          var product = data[row.attr("data-product-id")];
          if (!product || typeof product !== "object") {
            return;
          }
          var withVat = parseFloat(
            product.sale_price > 0 ? product.sale_price : product.price
          );
          var noVat = parseFloat(
            product.sale_vat_base > 0 ? product.sale_vat_base : product.vat_base
          );
          if (isFinite(withVat) && isFinite(noVat)) {
            row.find(".price .withvat").text(withVat.toFixed(2) + " €");
            row.find(".price .novat").text(noVat.toFixed(2) + " €");
          }
        });
      },
      // Includes HTTP errors, invalid JSON, timeouts, and missing product prices.
      complete: finish,
    });
  }

  $("body").on(
    "click",
    "form.navbar-form-search .all-results span",
    function () {
      $(this).closest("form.navbar-form-search").trigger("submit");
    }
  );
}

$(document).on("click", function (e) {
  if (
    !$(e.target).closest("#header-search-input").length &&
    !$(e.target).closest(".smart-search-results").length
  ) {
    searchResults.hide();
  }
});
